import { Button, Stack } from "@mui/material";
import {
  Link as RouterLink,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import { MeSectionNavigation } from "../components/MeSectionNavigation";
import type { MeInvitationsPageProps } from "../types";

export function MeInvitationsPage({
  courtInvitations,
  openPlayInvitations,
}: MeInvitationsPageProps) {
  const [params] = useSearchParams();
  const location = useLocation();
  const type = params.get("type") === "open_play" ? "open_play" : "court";
  function destination(nextType: string) {
    const next = new URLSearchParams(params);
    next.set("type", nextType);
    return {
      pathname: location.pathname,
      search: "?" + next.toString(),
      hash: location.hash,
    };
  }
  return (
    <Stack spacing={2}>
      <MeSectionNavigation active="activity" />
      <Stack
        component="nav"
        aria-label="Invitation types"
        direction="row"
        spacing={1}
        useFlexGap
        sx={{ flexWrap: "wrap" }}
      >
        {(
          [
            { id: "court", label: "Courts" },
            { id: "open_play", label: "Drop-in" },
          ] as const
        ).map((item) => (
          <Button
            key={item.id}
            component={RouterLink}
            to={destination(item.id)}
            size="small"
            variant={type === item.id ? "contained" : "outlined"}
            aria-current={type === item.id ? "page" : undefined}
          >
            {item.label}
          </Button>
        ))}
      </Stack>
      {type === "court" ? courtInvitations : openPlayInvitations}
    </Stack>
  );
}
